import { render, staticRenderFns } from "./PlanSave.vue?vue&type=template&id=5535f369"
import script from "./PlanSave.vue?vue&type=script&lang=js"
export * from "./PlanSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports